import type { User } from '@/app/types/global';

export const INSTALLER_KNOWLEDGE_INSTALLER_ID = 50;

export function canAccessInstallerKnowledge(
  user: Pick<User, 'role' | 'installer_id'> | null | undefined,
): boolean {
  return user?.role === 'admin'
    || (user?.role === 'installer' && user.installer_id === INSTALLER_KNOWLEDGE_INSTALLER_ID);
}
